import {
  NON_PAID_SUBSCRIPTIONS,
  SubscriptionType,
  SubscriptionTypeFlags,
} from '../../../shared/constants/user-info/subscription';

export const getIsNonPaidSubscription = (subscriptionType?: SubscriptionType) =>
  NON_PAID_SUBSCRIPTIONS.some((subscription) => subscriptionType === subscription);

export const getIsNonPaidSubscriptionFromFlags = (
  subscriptionTypeFlags: SubscriptionTypeFlags,
) =>
  Object.values(NON_PAID_SUBSCRIPTIONS).some(
    (flagName) => subscriptionTypeFlags[flagName],
  );
